module.exports = __webpack_public_path__ + "img/hr-boiler-S-idle.23c0c4fe.png";